// import js core
import 'core-js/stable'
import 'regenerator-runtime/runtime'

// import scripts
import Compiler from 'scripts/run'
import 'scripts/bem'

// import stylin
import './style.css'
import 'intl-tel-input/build/css/intlTelInput.css'

// import components
import * as blocks from './components'
import * as shoppingcart from '../../_shoppingcart/src'
import * as base from '../../_base/src/components'

const data = new FormData()
data.set('dirs', true)

$.ajax({
	method: 'POST',
	processData: false,
	contentType: false,
	cache: false,
	url: '/',
	data: data,
	success: function (data) {
		let newbase = { ...base }
		if (data.components.length > 0) {
			data.components.forEach((element) => {
				delete newbase[element]
			})
		}

		if (data.error) {
			// eslint-disable-next-line no-console
			console.warn(data.error_message)
		}

		Compiler.run({ ...blocks, ...shoppingcart, ...newbase })
	},
})
